export function getNewSelectedItems(selectedItems, chipIndex) {
    const newSelectedItems = [...selectedItems];
    const itemIndex = newSelectedItems.indexOf(chipIndex);
    if (itemIndex >= 0) {
        newSelectedItems.splice(itemIndex, 1);
    }
    else {
        newSelectedItems.push(chipIndex);
    }
    return newSelectedItems;
}
export function hasTitle(c) {
    return c.title && c.title.length > 0;
}
export function hasIcon(c) {
    return c.icon && c.icon.length > 0;
}
export function isSelected(selected, c) {
    return selected.indexOf(c.value) >= 0;
}
